import { PrimeReactModal } from "@finanedi.es/storybook"
import { PRIME_REACT_MODAL_DEFAULT_PROPS } from "features/Tesoreria/pages/Bancos/components/AfterBanksForm/src/_constants"
import { DefaultTFuncReturn } from "i18next"

interface ModalDetailProps {
  onCancel: () => void
  visible: boolean
  children: React.ReactNode
  modalTitle?: DefaultTFuncReturn
}

function ModalDetail({
  onCancel,
  visible,
  children,
  modalTitle,
}: ModalDetailProps) {
  return (
    <PrimeReactModal
      visible={visible}
      onHide={onCancel}
      closeOnEscape
      ptContext={{
        dialog: {
          ...PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
          headerTitle: {
            className:
              "tw-text-2xl tw-font-medium tw-text-primary tw-cursor-move",
          },
        },
      }}
      className='tw-w-5/6 tw-max-w-screen-2xl tw-h-5/6 tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      header={modalTitle}
      footer={null}
    >
      {children}
    </PrimeReactModal>
  )
}

export default ModalDetail
